import { observable } from "mobx";
import { Type } from "class-transformer";
import Request from "./request";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RequestList {
  @observable
  total!: number;

  @observable
  @Type(() => Request)
  requests!: Request[];

  static ValidationRules = {
    total: { required: true, number: true },
    requests: { required: true },
  };
}
